import React, { useState, useEffect } from 'react';
import { FaArrowUp, FaArrowDown, FaSync } from 'react-icons/fa';
import { alert_error, copy_native } from "../../../../AppContext";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';

export default function ProductTable({
    services_categorys,
    isOpen,
    setIsOpen
}) {
    const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
    const [data_acount, set_data_acount] = useState([]);
    const accounts_load_show = useSelector(state => state.accounts_load_show);

    // map column key -> actual data field
    const fieldMap = {
        price: 'accounts_price',
        amount: 'accounts_amount'
    };

    const getIcon = (colKey) => {
        if (sortConfig.key !== colKey) {
            return <FaSync className="inline ml-1 text-xs text-gray-300" />;
        }
        return sortConfig.direction === 'ascending'
            ? <FaArrowUp className="inline ml-1 text-xs" />
            : <FaArrowDown className="inline ml-1 text-xs" />;
    };

    const toNumber = (val) => {
        if (val === null || val === undefined) return 0;
        const s = String(val).replace(/[^0-9.-]+/g, ''); // loại bỏ ký tự không phải số
        const n = parseFloat(s);
        return isNaN(n) ? 0 : n;
    };

    const onSort = (key) => {
        const field = fieldMap[key] || key; // fallback nếu dùng tên thực luôn
        // Toggle logic: default first click = descending
        let direction = 'descending';
        if (sortConfig.key === key && sortConfig.direction === 'descending') {
            direction = 'ascending';
        }
        setSortConfig({ key, direction });

        // debug để kiểm tra event có chạy hay ko
        // mở console trong trình duyệt để xem
        console.log('onSort called:', { key, field, direction });

        const sorted = [...data_acount].sort((a, b) => {
            // nếu là 2 cột numeric (price/amount) --> so số
            if (key === 'price' || key === 'amount') {
                const aVal = toNumber(a[field]);
                const bVal = toNumber(b[field]);
                if (aVal < bVal) return direction === 'ascending' ? -1 : 1;
                if (aVal > bVal) return direction === 'ascending' ? 1 : -1;
                return 0;
            }
            // else: string compare
            const aStr = String(a[field] ?? '').toLowerCase();
            const bStr = String(b[field] ?? '').toLowerCase();
            if (aStr < bStr) return direction === 'ascending' ? -1 : 1;
            if (aStr > bStr) return direction === 'ascending' ? 1 : -1;
            return 0;
        });

        set_data_acount(sorted);
    };

    useEffect(() => {
        if (services_categorys && services_categorys.length > 0) {
            // clone để tránh thay đổi trực tiếp prop
            set_data_acount(Array.isArray(services_categorys) ? [...services_categorys] : services_categorys);
        } else {
            alert_error('no service');
            set_data_acount([]);
        }
    }, [services_categorys]);

    return (
        <div className="mt-2" >
            <table className="mt-1 table-fixed relative w-full border border-separate text-break text-sm">
                <thead className="bg-blue-500 text-white">
                    <tr>
                        <th className="py-3 px-2" style={{ width: '8%' }}>
                            ID
                        </th>
                        <th className="py-3 px-2" style={{ width: '35%' }}>
                            Tên sản phẩm
                        </th>
                        <th
                            className="text-left cursor-pointer select-none"
                            style={{ width: '10%' }}
                            onClick={() => onSort('price')}
                        >
                            Giá {getIcon('price')}
                        </th>
                        <th
                            className="cursor-pointer select-none"
                            style={{ width: '8%' }}
                            onClick={() => onSort('amount')}
                        >
                            Hiện có {getIcon('amount')}
                        </th>
                        <th className="text-left" style={{ width: '8%' }}>
                            Mode
                        </th>
                        <th className="py-3 px-2 text-left" style={{ width: '45%' }}>
                            Mô tả
                        </th>
                    </tr>
                </thead>

                <tbody>
                    {data_acount && data_acount.map(item_account => (
                        <tr
                            key={item_account.id}
                            className="bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 lg:text-black"
                        >
                            <td
                                className="text-center"
                                onClick={() => copy_native(String(item_account.id))}
                                title="Click to copy ID"
                            >
                                {item_account.id}
                            </td>
                            <td className="font-medium capitalize">
                                {item_account.accounts_caption ? (
                                    <a
                                        className="flex items-center gap-1 text-black no-underline"
                                        href={`/shop/accounts/product/play/${item_account.accounts_alias}_${item_account.id}`}
                                    >
                                        <div className="text-sm">
                                            {'\u27A4'} {(() => {
                                                const words = item_account.accounts_caption.split(' ');
                                                if (words.length > 18) {
                                                    return words.slice(0, 18).join(' ') + ' ...';
                                                }
                                                return item_account.accounts_caption;
                                            })()}
                                        </div>
                                    </a>
                                ) : (
                                    <span className="text-sm text-gray-500">No name</span>
                                )}
                            </td>
                            <td className="text-base">{item_account.accounts_price}</td>
                            <td className="text-base">{item_account.accounts_amount}</td>
                            <td className="">
                                {item_account.accounts_type === "local"
                                    ? "Trong kho"
                                    : item_account.accounts_type === "api"
                                        ? "Qua API"
                                        : item_account.accounts_type}
                            </td>
                            <td className="">
                                <div id={item_account.id}>
                                    {item_account.accounts_caption &&
                                        <div
                                            className="text-xs"
                                            dangerouslySetInnerHTML={{
                                                __html: (() => {
                                                    const words = item_account.accounts_description.split(' ');
                                                    if (words.length > 20) {
                                                        return words.slice(0, 20).join(' ') + ' ...';
                                                    }
                                                    return item_account.accounts_description;
                                                })()
                                            }}
                                        />
                                    }

                                    <div className="float-right">
                                        <Link
                                            to={`/shop/accounts/product/play/${item_account.accounts_alias}_${item_account.id}`}
                                            className="text-xs flex font-medium rounded-full px-3 py-1 space-x-1 bg-white text-black no-underline"
                                        >
                                            {accounts_load_show ? (
                                                <div className="spinner-border spinner-border-sm" role="status" />
                                            ) : (
                                                <div>Xem ngay</div>
                                            )}
                                        </Link>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
